import React, { useState } from 'react';
import BrushIcon from '@mui/icons-material/Brush';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import MessageModal from '../message-modal/MessageModal';
import { useCheckPermission } from '../hooks/useCheckPermission';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { USER_PERMISSIONS } from '../constants/permissions';

interface NotesEditButtonProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const NotesEditButton = ({ onEdit, onDelete }: NotesEditButtonProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);

  const checkPermission = useCheckPermission();

  const checkUserPermissionUpdateNote = () => {
    if (location.pathname.includes(ROUTES.BUSINESS_PROFILE)) {
      return checkPermission(USER_PERMISSIONS.ORG_BUSINESS_PROFILE_UPDATE_NOTE);
    } else if (location.pathname.includes(ROUTES.CUSTOMER_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_UPDATE_NOTE);
    } else if (location.pathname.includes(ROUTES.SUPPLIER_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_UPDATE_NOTE);
    } else if (location.pathname.includes(ROUTES.EMPLOYEE_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_EMPLOYEE_PROFILE_UPDATE_NOTE);
    }
  };

  const checkUserPermissionDeleteNote = () => {
    if (location.pathname.includes(ROUTES.BUSINESS_PROFILE)) {
      return checkPermission(USER_PERMISSIONS.ORG_BUSINESS_PROFILE_DELETE_NOTE);
    } else if (location.pathname.includes(ROUTES.CUSTOMER_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_DELETE_NOTE);
    } else if (location.pathname.includes(ROUTES.SUPPLIER_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_DELETE_NOTE);
    } else if (location.pathname.includes(ROUTES.EMPLOYEE_PROFILES)) {
      return checkPermission(USER_PERMISSIONS.ORG_EMPLOYEE_PROFILE_DELETE_NOTE);
    }
  };

  return (
    <>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteNote')}
          modalMessage={t('messages.deleteNoteDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <Tooltip
        title={
          checkUserPermissionUpdateNote() ? t('buttons.edit') : t('messages.contactAdministrator')
        }
        placement='top'
        arrow
      >
        <IconButton
          size='small'
          onClick={() => {
            onEdit();
          }}
          disabled={!checkUserPermissionUpdateNote()}
        >
          <BrushIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={
          checkUserPermissionDeleteNote() ? t('buttons.delete') : t('messages.contactAdministrator')
        }
        placement='top'
        arrow
      >
        <IconButton
          size='small'
          onClick={() => {
            setDeleteMessageModalOpen(true);
          }}
          disabled={!checkUserPermissionDeleteNote()}
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default NotesEditButton;
